const LOGIN_BASE = window.location.hostname === 'localhost' ? 'https://identint.familysearch.org' : ''

export default {
  // Authn may redirect to /error so do not change the value
  ERROR: '/error',
  FEATURE_UNAVAILABLE: '/feature-unavailable',
  LOCATION_AGE_RESTRICTION: '/location-age-restriction',
  // Will be passed as returnUrl by native mobile app when using a web view for sign up
  // Note that currently the native mobile app will be using /register/mobile/success as the pathname
  MOBILE_SUCCESS: '/mobile/success',
  SESSION_EXPIRED: '/session-expired',
  VERIFY_EMAIL: '/verify/email',
  VERIFY_EMAIL_EXPIRED: '/verify/email/expired',
  VERIFY_EMAIL_SUCCESS: '/verify/email/success',

  // #region dynamic URLs
  link: (provider) => `${LOGIN_BASE}/identity/login/link?provider=${provider}`,
  linkExistingAccount: (provider) => `${LOGIN_BASE}/identity/login/link/existing-account?provider=${provider}`,

  // #endregion
}
